import React from "react";
import { useIntl } from "react-intl";
import { Row, Col, Menu, Tooltip, Layout, Typography } from "antd";

import config from "../../../config";
import FooterIcon from "./footerIcon";
import NavBarLink from "../mainMenu/navBarLink";
import { version } from "../../../../package.json";

import "./index.css";

const year = new Date().getFullYear();

const { Item } = Menu;
const { Text } = Typography;

const Footer = () => {
  const intl = useIntl();
  return (
    <Layout.Footer className="footer">
      <Row>
        <Col span={20}>
          <Row>
            <Col>
              <Text strong className="dhl-name">
                Deutsche Post DHL Group
              </Text>
            </Col>
          </Row>
          <Row className="footer-menu">
            <Col>
              <Menu mode="horizontal">
                <Item key={1}>
                  <NavBarLink
                    id="footer.fraud"
                    defaultMessage="Informace o podvodech"
                    href={config.FRAUD_URL}
                  />
                </Item>
                <Item key={2}>
                  <NavBarLink
                    id="footer.legal"
                    defaultMessage="Právní oznámení"
                    href={config.LEGAL_URL}
                  />
                </Item>
                <Item key={3}>
                  <NavBarLink
                    id="footer.terms"
                    defaultMessage="Smluvní podmínky"
                    href={config.CONTRACTUAL_URL}
                  />
                </Item>
                <Item key={4}>
                  <NavBarLink
                    id="footer.privacy"
                    defaultMessage="Oznámení o ochraně soukromí"
                    href={config.PRIVACY_URL}
                  />
                </Item>
                <Item key={5}>
                  <NavBarLink
                    id="footer.conflict"
                    defaultMessage="Řešení sporů"
                    href={config.DISPUTE_URL}
                  />
                </Item>
                <Item key={6}>
                  <NavBarLink
                    id="footer.access"
                    defaultMessage="Přístupnost"
                    href={config.ACCESSIBILITY_URL}
                  />
                </Item>
              </Menu>
            </Col>
          </Row>
        </Col>
        <Col span={4} className="footer-social">
          <Row>
            <Col>
              <Text strong>
                {intl.formatMessage({
                  id: "footer.follow",
                  defaultMessage: "Sledujte nás na",
                })}
              </Text>
            </Col>
          </Row>
          <Row type="flex" align="middle" className="footer-social-icons">
            <Col>
              <FooterIcon href={config.YOUTUBE_URL} icon="youtube" />
              <FooterIcon href={config.FACEBOOK_URL} icon="facebook" />
              <FooterIcon href={config.LINKEDIN_URL} icon="linkedin" />
              <FooterIcon href={config.INSTAGRAM_URL} icon="instagram" />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col className="center">
          <Tooltip
            title={intl.formatMessage(
              {
                id: "footer.version",
                defaultMessage: "verze webové aplikace {version}",
              },
              { version }
            )}
          >
            <Text>
              {intl.formatMessage(
                {
                  id: "footer.rights",
                  defaultMessage:
                    "{year} © DHL Freight CZ, s.r.o. Všechna práva vyhrazena.",
                },
                { year }
              )}
            </Text>
          </Tooltip>
        </Col>
      </Row>
    </Layout.Footer>
  );
};

export default Footer;
